import { render, staticRenderFns } from "./ViewerComponent.vue?vue&type=template&id=99c3771e&scoped=true&"
import script from "./ViewerComponent.vue?vue&type=script&lang=js&"
export * from "./ViewerComponent.vue?vue&type=script&lang=js&"
import style0 from "./ViewerComponent.vue?vue&type=style&index=0&id=99c3771e&prod&lang=scss&scoped=true&"
import style1 from "./ViewerComponent.vue?vue&type=style&index=1&id=99c3771e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c3771e",
  null
  
)

export default component.exports